import { ReactNode } from 'react'
import { cn } from '../../../../app/utils/cn'

interface TabProps {
  children: ReactNode
  onSelect?: () => void
  isActive?: boolean
}
export default function Tab({
  children,
  isActive = false,
  onSelect,
}: TabProps) {
  return (
    <span
      onClick={onSelect}
      className={cn(
        'flex cursor-pointer items-end gap-2.5 p-4 font-semibold text-black04',
        isActive && 'border-b-2 border-b-black text-black01',
      )}
    >
      {children}
    </span>
  )
}
